/* Solis marketplace PDP — small glue on top of the theme's own variant/cart JS.
   1. After a variant change, swap every [data-amzp-sync] node from the re-rendered page HTML
      (the theme's variant picker fetches the whole page and hands it over on the event promise).
   2. Price under each image swatch tile.
   3. "Buy Now": add the current form to the cart, then go to checkout. */
(function () {
  function tilePrices(root) {
    var json = root.querySelector('script[data-amzp-prices]');
    if (!json) return;
    var prices;
    try { prices = JSON.parse(json.textContent); } catch (e) { return; }
    root.querySelectorAll('.variant-option--variant-images input[data-variant-id]').forEach(function (input) {
      var label = input.closest('label');
      var p = prices[input.getAttribute('data-variant-id')];
      if (!label || !p) return;
      var el = label.querySelector('.amzp-tile-price');
      if (!el) {
        el = document.createElement('span');
        el.className = 'amzp-tile-price';
        el.setAttribute('aria-hidden', 'true');
        label.appendChild(el);
      }
      el.textContent = p;
      // 2026-10-28: the option name under the tile too (tiles showed only a price: Iron Man figures, Exhaust Mist…)
      var nm = label.querySelector('.amzp-tile-name');
      if (!nm) {
        nm = document.createElement('span');
        nm.className = 'amzp-tile-name';
        nm.setAttribute('aria-hidden', 'true');
        label.insertBefore(nm, el);
      }
      nm.textContent = input.value;
    });
  }

  // Products flagged custom.open_first_variant: open on the first variant (even sold out) when the URL names none.
  function openFirst(root) {
    var id = root.getAttribute('data-amzp-open-first');
    if (!id || /[?&]variant=/.test(location.search)) return;
    // wait until the theme's <variant-picker> is upgraded, otherwise its change handler (and the stock/buy-box
    // refresh that hangs on it) never runs
    var go = function () {
      var input = root.querySelector('.amzp-variants input[data-variant-id="' + id + '"]');
      if (input && !input.checked) input.click();
    };
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('variant-picker').then(function () { requestAnimationFrame(go); });
    } else { window.addEventListener('load', go); }
  }

  function init() {
    document.querySelectorAll('[data-amzp]').forEach(function (root) { tilePrices(root); openFirst(root); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  document.addEventListener('shopify:product:select', function (e) {
    var root = e.target instanceof Element && e.target.closest('[data-amzp]');
    if (!root || !e.promise) return;
    e.promise.then(function (res) {
      var html = res && res.detail && res.detail.html;
      if (!html) return;
      root.querySelectorAll('[data-amzp-sync]').forEach(function (el) {
        var fresh = html.querySelector('[data-amzp-sync="' + el.getAttribute('data-amzp-sync') + '"]');
        if (fresh) el.replaceWith(document.importNode(fresh, true));
      });
      tilePrices(root);
    }).catch(function () {});
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-amzp-buynow]');
    if (!btn) return;
    var root = btn.closest('[data-amzp]');
    var form = root && root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    btn.disabled = true;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = '/checkout';
    }).catch(function () {
      btn.disabled = false;
      form.requestSubmit ? form.requestSubmit() : form.submit(); // fall back to the theme's own add-to-cart + error message
    });
  });
})();
